<template>
	<div class="heardBox">
		<div class="topHead">
			<div class="Icon">
				<img @click="homeBtn" class="supHove2" :src="$assetUrl(appLogo && appLogo.configValue)" alt="" />
				<searchSousuo v-if="!isHideSearch" />
			</div>
			<div class="topHeadRig">
				<div class="icons" v-if="!infoData || !infoData.avatar">
					<i class="el-icon-user-solid"></i>
				</div>
				<img :src="$imgUrl + infoData.avatar" v-else alt="" class="icons" />
				<span>{{ infoData ? infoData.nickName : '' }}</span>
				<div class="infoBox" v-if="loginToModule === '1' || !loginToModule">
					<div class="infoXinx" @click="grBtn">
						<div class="icon" v-if="!infoData || !infoData.avatar">
							<i class="el-icon-user-solid"></i>
						</div>
						<img :src="$imgUrl + infoData.avatar" v-else alt="" class="icon" />
						<div class="infoTxt">
							<div class="infoName">{{ infoData ? infoData.nickName : '' }}</div>
							<p :title="infoData ? infoData.school : ''">{{ infoData ? infoData.school : '' }}</p>
						</div>
						<img src="@/assets/img/jr (3).svg" alt="" class="imgs" />
					</div>
					<div class="infoAto">
						<div class="infoItem active" @click="grBtn">
							<img src="@/assets/img/gr.svg" alt="" class="imgs" />
							<p>个人信息</p>
							<img src="@/assets/img/jr (3).svg" alt="" class="icon" />
						</div>
						<div class="infoItem" @click="bzBtn">
							<img src="@/assets/img/bz.svg" alt="" class="imgs" />
							<p>帮助中心</p>
							<img src="@/assets/img/jr (3).svg" alt="" class="icon" />
						</div>
						<div class="infoItem" @click="tcBtn">
							<img src="@/assets/img/tc.svg" alt="" class="imgs" />
							<p>退出登录</p>
							<img src="@/assets/img/jr (3).svg" alt="" class="icon" />
						</div>
					</div>
				</div>
				<div class="infoBox infoBox2" v-else-if="loginToModule === '2'">
					<div class="infoAto">
						<div class="infoItem" @click="tcBtn">
							<img src="@/assets/img/tc.svg" alt="" class="imgs" />
							<p>退出登录</p>
							<img src="@/assets/img/jr (3).svg" alt="" class="icon" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import searchSousuo from '@/components/pubComponents/searchSousuo';
import { mapState } from 'vuex';

export default {
	name: 'brieHeader',
	data() {
		return {
			loginToModule: localStorage.getItem('loginToModule')
		};
	},
	props: {
		isHideSearch: {
			type: Boolean,
			default: false
		}
	},
	components: {
		searchSousuo
	},
	computed: {
		...mapState(['infoData', 'appLogo'])
	},
	methods: {
		grBtn() {
			this.$store.commit('setCachedComponents', '');
			setTimeout(() => {
				this.$store.commit('setCachedComponents', 'myInfo');
			}, 1000);
			this.$router.push({
				path: 'myInfo',
				query: {}
			});
		},
		bzBtn() {
			this.$router.push({
				path: 'feedback'
			});
		},
		homeBtn() {
			this.$router.push({
				path: 'home'
			});
		},
		tcBtn() {
			localStorage.clear();
			this.$store.commit('tabFn', 1);
			this.$router.replace({
				path: 'login'
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.heardBox {
	height: 60px;
	background: #ffffff;
	box-sizing: border-box;
	border: 1px solid #f3f4f7;
	.topHead {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 100%;
		.Icon {
			display: flex;
			align-items: center;
			img {
				height: 32px;
				margin-right: 112px;
				cursor: pointer;
			}
		}
		.topHeadRig {
			display: flex;
			align-items: center;
			cursor: pointer;
			height: 100%;
			position: relative;
			&:hover {
				.infoBox {
					display: block;
				}
			}
			.icons {
				width: 24px;
				height: 24px;
				display: flex;
				background: #f1f2f5;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				margin-right: 9px;
				object-fit: cover;
				i {
					font-size: 16px;
					color: #babbbe;
				}
			}
			.infoBox {
				display: none;
				position: absolute;
				z-index: 99;
				width: 187px;
				background: #ffffff;
				box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.14);
				border-radius: 8px;
				border: 1px solid #ececed;
				padding: 0 7px;
				top: 59px;
				right: 0;
				&::before {
					content: '';
					position: absolute;
					top: -15px;
					left: 0;
					width: 100%;
					height: 15px;
				}
				&.infoBox2 {
					.infoAto {
						padding-top: 17px;
					}
				}
				.infoXinx {
					padding: 21px 0;
					display: flex;
					align-items: center;
					.icon {
						width: 37px;
						height: 37px;
						display: flex;
						background: #f1f2f5;
						justify-content: center;
						align-items: center;
						border-radius: 50%;
						margin-right: 7px;
						i {
							font-size: 24px;
							color: #babbbe;
						}
					}
					.infoTxt {
						flex: 1;
						padding-left: 11px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						.infoName {
							font-size: 14px;
							color: #000000;
						}
						p {
							width: 96px;
							font-size: 12px;
							color: #666666;
							overflow: hidden; /* 确保超出容器的内容被裁剪 */
							white-space: nowrap; /* 确保文本在一行内显示 */
							text-overflow: ellipsis; /* 超出部分显示省略号 */
						}
						&:hover {
							.infoName,
							p {
								color: #1d7b3a;
							}
						}
					}
					.imgs {
						margin-right: 13px;
						width: 6px;
						height: 10px;
					}
				}
			}
			.infoAto {
				.infoItem {
					display: flex;
					align-items: center;
					height: 32px;
					margin-bottom: 17px;
					padding-left: 5px;
					&:hover {
						background: #f8f9fa;
						border-radius: 2px;
						p {
							color: #1d7b3a;
						}
					}

					.imgs {
						width: 20px;
						height: 20px;
						margin-right: 4px;
					}
					p {
						color: #000000;
						font-size: 14px;
						flex: 1;
					}
					.icon {
						width: 6px;
						height: 10px;
						margin-right: 13px;
					}
				}
			}
			img {
				border-radius: 50%;
				width: 24px;
				height: 24px;
				margin-right: 9px;
			}
			span {
				color: #3d3d3d;
				font-size: 14px;
				margin-right: 14px;
			}
		}
	}
}
</style>
